var map = {
	"./loaders": 15577,
	"./loaders.json": 15577,
	"./logo-impulse-primary": 59821,
	"./logo-impulse-primary.json": 59821,
	"./spinner-middle-gray": 52190,
	"./spinner-middle-gray.json": 52190
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62487;